import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Zap, ArrowRight } from "lucide-react";

// Sticky bottom CTA bar — visible only on mobile, only on marketing pages,
// only after the user scrolls past the hero. Biggest single conversion lift
// for mobile healthcare apps.
const HIDE_ON = [
  /^\/patient/, /^\/doctor/, /^\/admin/, /^\/case\//, /^\/login/, /^\/signup/,
  /^\/forgot-password/, /^\/reset-password/,
];

export default function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();
  const hidden = HIDE_ON.some((rx) => rx.test(pathname));

  useEffect(() => {
    if (hidden) { setVisible(false); return; }
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [hidden, pathname]);

  if (hidden) return null;

  return (
    <div
      className={
        "fixed bottom-0 left-0 right-0 z-40 md:hidden transition-all duration-300 " +
        (visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none")
      }
      data-testid="sticky-mobile-cta"
      aria-hidden={!visible}
    >
      <div className="mx-3 mb-3 rounded-2xl bg-white shadow-2xl border border-slate-200 p-3 flex items-center gap-3 backdrop-blur">
        <div className="flex-1 min-w-0">
          <div className="text-[10px] font-semibold uppercase tracking-wider text-[#20C997] inline-flex items-center gap-1">
            <Zap className="w-3 h-3"/> Fast second opinion
          </div>
          <div className="font-heading font-semibold text-slate-900 text-sm truncate">
            From <span className="text-[#0B5ED7]">₹1,000</span> · verified specialist · 48 hrs
          </div>
        </div>
        <Link
          to="/login?as=patient"
          className="shrink-0 inline-flex items-center gap-1 px-4 h-11 rounded-xl bg-[#0B5ED7] hover:bg-[#084BB0] text-white text-sm font-semibold shadow-md"
          data-testid="sticky-cta-book"
        >
          Book now <ArrowRight className="w-4 h-4"/>
        </Link>
      </div>
    </div>
  );
}
